import { ChangeEvent, KeyboardEvent } from "react"
import { TextAreaRefs } from "./types"

interface TextAreaInputProps {
    value: string
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void
    onKeyDown: (event: KeyboardEvent<HTMLTextAreaElement>) => void
    autoFocus: boolean | undefined
    className: string | undefined
    onBlur: () => void
    onSelect: () => void
    disabled: boolean
    refs: TextAreaRefs
}

export const TextAreaInput = ({
    value,
    onChange,
    onKeyDown,
    autoFocus,
    className,
    onBlur,
    onSelect,
    disabled,
    refs
}: TextAreaInputProps) => {
    return (
        <textarea
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            autoFocus={autoFocus}
            className={className}
            ref={refs.textAreaRef}
            onBlur={onBlur}
            onSelect={onSelect}
            disabled={disabled}
        />
    )
}
